/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import Modal from "../../ChatCase/Modal/Modal";
import addFileIcone from "../../../../assets/icons/addFile.svg"
import "./styles.scss"

const AddFile = (
{
setShowModalRerender,
setShowModalNoRerender,
showModalNoRerender,
showModal,
cas
}) => {

const toggleModal = (e) => {
e.preventDefault()
// Affiche la modal d'upload des fichiers
setShowModalNoRerender(!showModalNoRerender);
};
return (
<div>
<div className="addFile">
<button className="addFile-button" onClick={toggleModal} type={"button"}>
<img src={addFileIcone} className={"addFile-button-icone"}/>
{showModalNoRerender &&
// Modal d'upload des docuements pour l'utilisateur
// Passage de props ChatCase -> Modal -> Uploadfile peut être pas nécéssaire, à revoir dans le container UplopadFile si on peut transmettre ces props
<Modal className="modalBackground"
							setShowModalRerender={setShowModalRerender}
							setShowModalNoRerender={setShowModalNoRerender}
							showModal={showModal}
							showModalNoRerender={showModalNoRerender}
							idCase={cas.id}
/>
}
</button>
</div>
</div>
);
};

AddFile.propTypes = {
setShowModalNoRerender: PropTypes.func,
setShowModalRerender: PropTypes.func,
idCase: PropTypes.string,
showModal: PropTypes.bool,
showModalNoRerender: PropTypes.bool,
};

export default AddFile;
